import {classNames} from "../../helpers";

const FormButton = ({ children, onClick, classes, disabled }) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={classNames(
        disabled ? 'bg-gray-200 text-gray-500 cursor-progress' : 'bg-artfulRed hover:bg-artfulRed-dark text-white',
        'transition-all duration-300 ease-in-out',
        'flex items-center justify-center px-5 py-2 rounded-md text-base whitespace-nowrap',
        classes,
      )}>
      { children }
    </button>
  )
};

export default FormButton;
